import { CREATE_RESIGNATION, GET_RESIGNATION } from "./types";
import { ResignationType } from "@type/HRM/resignation";

export const createResignationRequest = (data: ResignationType) => {
  return {
    type: CREATE_RESIGNATION.CREATE_RESIGNATION_REQUEST,
    payload: { data },
  } as const;
};

export const createResignationSuccess = (data: ResignationType) => {
  return {
    type: CREATE_RESIGNATION.CREATE_RESIGNATION_SUCCESS,
    payload: { data },
  } as const;
};

export const createResignationFailed = () => {
  return {
    type: CREATE_RESIGNATION.CREATE_RESIGNATION_FAILED,
  } as const;
};

export const getResignationRequest = (data: number) => {
  return {
    type: GET_RESIGNATION.GET_RESIGNATION_REQUEST,
    payload: { data },
  } as const;
};

export const getResignationSuccess = (data: ResignationType) => {
  return {
    type: GET_RESIGNATION.GET_RESIGNATION_SUCCESS,
    payload: { data },
  } as const;
};

export const getResignationFailed = () => {
  return {
    type: GET_RESIGNATION.GET_RESIGNATION_FAILED,
  } as const;
};

export type ResignationActions =
  | ReturnType<typeof createResignationRequest>
  | ReturnType<typeof createResignationSuccess>
  | ReturnType<typeof createResignationFailed>
  | ReturnType<typeof getResignationRequest>
  | ReturnType<typeof getResignationSuccess>
  | ReturnType<typeof getResignationFailed>;
